export enum EmployeeTypes {
  HRM = 'HRM',
  RS = 'RS',
}
